import { Schedule } from '../types';

export function actionable(schedule: Schedule): boolean {
  return schedule.status === 'active' || schedule.status === 'paused' || schedule.reactivatable;
}
